import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  button: {
    color: 'warning.main',
  },
};

export default styles;
